import { Page } from "@/components/Reveal";
import PageHero from "@/components/PageHero";
import BlogCard from "@/components/BlogCard";
import FAQSection from "@/components/FAQSection";
import SiteEnd from "@/components/SiteEnd";
import blogs from "@/data/blogs";

export default function Blogs() {
  return (
    <Page testId="blogs-page">
      <PageHero title="Blogs" testId="blogs-page-heading" />
      <section className="relative z-10 w-full px-6 mt-1">
        <div
          className="glass-surface relative rounded-[32px] py-12 sm:py-24 overflow-hidden"
        >
          <div data-testid="blogs-grid" className="relative site-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogs.map((post, i) => (
              <BlogCard key={post.slug} post={post} index={i} showImage />
            ))}
          </div>
        </div>
      </section>
      <FAQSection />
      <SiteEnd />
    </Page>
  );
}
